import { httpRequest } from '@calendly/http-tools'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

import { featureRootSelector } from '../../../selectors'

export const subscriptionReactivationState = createSelector(
  featureRootSelector,
  ({ reactivation }) => reactivation.state
)

export const reactivateSubscription = createAsyncThunk(
  'currentSubscription/reactivate',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/reactivate',
      method: 'POST'
    })

    if (!success) return rejectWithValue(response)

    return response
  }
)

const reactivationSlice = createSlice({
  name: 'subscriptionReactivation',
  initialState: {
    state: 'initial'
  },
  reducers: {
    reset: (state) => {
      state.state = 'initial'
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reactivateSubscription.pending, (state, _action) => {
      state.state = 'pending'
    })
    builder.addCase(reactivateSubscription.fulfilled, (state, _action) => {
      state.state = 'completed'
    })
    builder.addCase(reactivateSubscription.rejected, (state, _action) => {
      state.state = 'failed'
    })
  }
})

export const {
  reducer,
  actions: { reset }
} = reactivationSlice
